import { getRound } from "../pages/redux/helpers/helper_functions";

function fallbackParse(raw) {
  try {
    let list = raw;
    if (typeof list === "string") {
      list = JSON.parse(list);
    }
    if (list == null) {
      return { coins: [], pairedPrices: {}, error: "empty" };
    }
    if (!Array.isArray(list)) {
      list = Object.values(list);
    }
    if (!Array.isArray(list) || list.length === 0) {
      return { coins: [], pairedPrices: {}, error: null };
    }
    const pairedPrices = {};
    for (let i = 0; i < list.length; i++) {
      const d = list[i];
      if (d && d.symbol) {
        pairedPrices[d.symbol] = getRound(d.current_price);
      }
    }
    return { coins: list, pairedPrices, error: null };
  } catch (err) {
    return {
      coins: [],
      pairedPrices: {},
      error: err && err.message ? err.message : String(err),
    };
  }
}

let worker;
let nextId = 1;
const pending = new Map();

/**
 * Normalizes socket `cmc_updated` payload and builds paired price map off the main thread.
 */
export function parseCmcUpdatedPayload(raw) {
  if (typeof Worker === "undefined") {
    return Promise.resolve(fallbackParse(raw));
  }

  return new Promise((resolve) => {
    if (!worker) {
      try {
        worker = new Worker(
          new URL("./cmcUpdatedParse.worker.js", import.meta.url)
        );
        worker.onmessage = (ev) => {
          const { id, ...rest } = ev.data || {};
          const cb = pending.get(id);
          pending.delete(id);
          if (cb) cb(rest);
        };
      } catch {
        resolve(fallbackParse(raw));
        return;
      }
    }

    const id = nextId++;
    pending.set(id, resolve);
    try {
      worker.postMessage({ id, payload: raw });
    } catch {
      pending.delete(id);
      resolve(fallbackParse(raw));
    }
  });
}
